import type { Incident } from '../../services/incidentsApi';

export type JourneyStepId =
  | 'step0'
  | 'step1'
  | 'step2'
  | 'step3'
  | 'step4'
  | 'step5'
  | 'step6'
  | 'step7'
  | 'step8';

export type JourneyPhaseId = 'detect' | 'verify' | 'decide' | 'follow_up' | 'closeout';

export const JOURNEY_PROGRESS_STORAGE_PREFIX = 'incidents.reviewJourneyProgress.v1';
export const EVIDENCE_REVIEW_STEP_ID: JourneyStepId = 'step2';

export type JourneyProgressSnapshot = {
  completed_step_ids?: string[];
  evidence_fingerprint?: string;
};

export function normalizeJourneyFingerprintText(value: unknown): string {
  return String(value || '').trim();
}

export function buildJourneyEvidenceFingerprint(incident: Incident | Record<string, any> | null | undefined): string {
  if (!incident) return '';
  const attachments = Array.isArray(incident?.evidence?.attachments)
    ? [...incident.evidence.attachments]
        .map((attachment: any) => ({
          filename: normalizeJourneyFingerprintText(attachment?.filename),
          type: normalizeJourneyFingerprintText(attachment?.type),
          uploaded_at: normalizeJourneyFingerprintText(attachment?.uploaded_at),
          size: Number(attachment?.size || 0) || 0,
        }))
        .sort((left, right) =>
          `${left.filename}|${left.type}|${left.uploaded_at}|${left.size}`.localeCompare(
            `${right.filename}|${right.type}|${right.uploaded_at}|${right.size}`,
          ),
        )
    : [];

  const latestEvidence = incident?.evidence?.latest || {};
  const reviewMedia = incident?.review_media || {};

  return JSON.stringify({
    snapshot_status: normalizeJourneyFingerprintText(incident?.snapshot_status),
    clip_status: normalizeJourneyFingerprintText(incident?.clip_status),
    meta_status: normalizeJourneyFingerprintText(incident?.meta_status),
    attachment_count: attachments.length,
    attachments,
    latest_snapshot: normalizeJourneyFingerprintText(latestEvidence?.snapshot?.filename),
    latest_video: normalizeJourneyFingerprintText(latestEvidence?.video?.filename),
    review_snapshot: normalizeJourneyFingerprintText(reviewMedia?.source_truth?.snapshot?.filename),
    review_clip: normalizeJourneyFingerprintText(reviewMedia?.source_truth?.clip?.filename),
  });
}

export const createReviewSessionId = (): string => {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch {
    // ignore
  }
  return `review-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};
